import { Api } from '@/Api';
import { useRoute } from 'vue-router';
import { DEBUG_NAMESPACE, useDebug } from '@/composables/useDebug';
import { TrackEvents, TrackClickEvents, useTrack } from '@/composables/useTrack';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const { debug } = useDebug(DEBUG_NAMESPACE.TRACKING);

// Re-export for convenience
export { TrackEvents, TrackClickEvents };

export const useViewerTrack = () => {
  const route = useRoute();
  const itemStore = useViewerItemStore();
  const { track, trackClick, identify } = useTrack();

  const trackItemOwner = (event: TrackEvents, data: any = {}, asBeacon?: false) => {
    const trackData = {
      params: route?.params,
      route: route?.name,
      design: 'copernicus',
      item_type: itemStore.type,
      hashid: itemStore.id,
      source_app: 'web',
      ...data,
    };

    debug(`[trackItemOwner] - ${event}`, trackData);
    return Api.track.create(event, trackData, asBeacon);
  };

  return { track, trackItemOwner, trackClick, identify };
};
